import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import { Navbar, Nav, Container, Button, Col, Card, ProgressBar, Form, Accordion, Image } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { MdExpandMore, MdExpandLess } from 'react-icons/md'
import { signInWithGoogle, signOut, firestore } from '../firebase/firebase-utils';
import Qrcode from '../assets/founders/qrcode.png'
import './styles.scss';
import CheckImg from '../assets/check.svg'

const MyOrders = (props) => {
    const [orders, setorders] = useState([]);
    const [details, setdetails] = useState(null);
    const [progress, setprogress] = useState(0);
    const [error, seterror] = useState('');
    const [rating, setrating] = useState(0);
    const [review, setreview] = useState('');
    useEffect(() => {
        if (props.user) {
            firestore.collection("Orders").where('userId', '==', props.user.uid)
                .onSnapshot(querySnapshot => {
                    const orders = querySnapshot.docs.map(doc => {
                        return {
                            ...doc.data(),
                            id: doc.id
                        }
                    })
                    setorders(orders)
                })
        }
        else {
            setorders([]);
        }
    }, [props.user]);

    const cancelOrder = (id) => {
        firestore.collection('Orders').doc(id).update({ status: 0 })
    }

    const uploadHandler = (project) => {
        let files = document.getElementById('dev_files').files
        let size = 0;
        for (let i = 0; i < files.length; i++) {
            size = size + files[i].size;
        }
        if (size < 25000000) {
            for (let i = 0; i < files.length; i++) {
                seterror('')
                uploadfile(files[i], project)
            }
        }
        else {
            seterror('File Size Limited to 25 MB')
        }
    }

    const uploadfile = (file, project) => {
        let storageRef = firebase.storage().ref(`files/${project}/${file.name}`);

        let uploadTask = storageRef.put(file);

        uploadTask.on('state_changed', (snapshot) => {
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setprogress(Math.floor(progress))
        }, (error) => {
            console.log(error.message);
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then(() => {
                console.log('uploaded')
            })
        })
    }

    const reviewHandler = (id) => {
        if (rating === 0 || review === '') {
            alert('Fill empty fields');
        }
        else {
            firestore.collection('Orders').doc(id).update({
                rating: rating,
                review: review
            })
                .then(() => {
                    alert('Thanks for rating');
                    setrating(0);
                    setreview('')
                })
        }
    }

    return (
        <div className="myOrders">
            <Navbar className='Nav' collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand className="NavLogo" as={Link} to="/"><span>T</span>ech<span>S</span>eminal</Navbar.Brand>
                    <Navbar.Toggle className="toogle-btn" aria-controls="responsive-navbar-nav">
                        <FaBars />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link as={Link} className="navLinks" to="/freelance">Home</Nav.Link>
                            <Nav.Link className="navLinks" as={Link} to="/freelance#categories" >Categories</Nav.Link>
                            <Nav.Link as={Link} className="navLinks" to="/freelance/ourwork">Our-work</Nav.Link>
                            {
                                !props.user ?
                                    <Button onClick={signInWithGoogle} className="actionBtn">Sign In</Button>
                                    :
                                    <Button onClick={() => { signOut(); window.location.reload() }} className="actionBtn">Sign Out</Button>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <header>
                <Container>
                    {props.user ?
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', background: '#fff', borderRadius: '20px', padding: '20px' }}>
                            <div style={{ display: 'flex' }}>
                                <Image style={{ height: '50px', borderRadius: '50%',marginBottom:'20px' }} src={props.user.photoURL} fluid />
                                <div style={{ margin: '0 10px', lineHeight: '10px' }}>
                                    <h5 style={{ fontFamily: 'Poppins' }}>{props.user.displayName}</h5>
                                    <p style={{ color: 'gray' }}>{props.user.email}</p>
                                </div>
                            </div>
                            <Button as='a' href="mailto:techseminal@gmail.com" style={{ borderRadius: '25px', margin:'10px' }}>send mail</Button>
                        </div> : null
                    }
                    {orders.length === 0 ? <div style={{ marginTop: '50px' }}><center>NO ORDERS PLACED YET!!!<br /><br /><Button as={Link} to="/freelance#categories">Place an Order</Button></center></div> : orders.sort((a, b) => (b.orderTime) - (a.orderTime)).map(order => {
                        return (
                            <Col sm={12} style={{ margin: '30px auto' }} key={order.id}>
                                <Card className="Order">
                                    <div className="header">
                                        <h6>TS - {order.id}</h6>
                                        <p>{order.orderDate}</p>
                                    </div>
                                    <Card.Body>
                                        <h5 className="project">{order.project}</h5>
                                        <p className="descrp">{order.discrp}</p>

                                        {/* Status bar */}
                                        {order.status !== 0 ?
                                            <>
                                                <ProgressBar now={order.status} />
                                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{order.status}%</p>
                                            </>
                                            :
                                            null}


                                        {order.status === 0 ? <div style={{ color: 'red' }}>ORDER CANCELLED</div> : null}
                                        {order.status !== 0 ?
                                            <div style={{ cursor: 'pointer', color: 'blue', float: 'right' }}
                                                onClick={() => details !== order.id ? setdetails(order.id) : setdetails(null)}>
                                                {details === order.id ? <div>Show less<MdExpandLess /></div>
                                                    : <div>More Details<MdExpandMore /></div>}</div>
                                            : null}

                                        {details === order.id ?
                                            <div id="details">
                                                <div className="status">
                                                    <Accordion>

                                                        {/* for status > 10 */}
                                                        {order.status > 19 ?
                                                            <>
                                                                <Card>
                                                                    <Card.Header>
                                                                        <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="0">
                                                                            Order Placed
                                                                            <Image src={CheckImg} fluid />
                                                                        </Accordion.Toggle>
                                                                    </Card.Header>
                                                                    <Accordion.Collapse eventKey="0">
                                                                        <Card.Body style={{ fontFamily: 'Nunito', lineHeight: '30px' }}>
                                                                            <p>Project Name: <span>{order.project}</span></p>
                                                                            <p>E-mail: <span>{order.email}</span></p>
                                                                            {order.phone !== '' ? <p>Moble Number: <span>{order.phone}</span></p> : null}
                                                                            <p>Category: <span>{order.category}</span></p>
                                                                            <Button className="cancel_order" variant="danger" disabled={order.status > 59 ? true : false} onClick={() => cancelOrder(order.id)}>CANCEL ORDER</Button><br /><br />
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Card>
                                                            </>
                                                            : null}

                                                        {/* for status > 39    */}
                                                        {order.status > 39 ?
                                                            <Card>
                                                                <Card.Header>
                                                                    <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="1">
                                                                        Billing
                                                                        <Image src={CheckImg} fluid />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="1">
                                                                    <Card.Body>
                                                                        <p>TOTAL PRICE: <span>₹{order.price}</span>/-</p>
                                                                        <p>ADVANCE: <span>₹{order.price * 20 / 100}/-</span></p><br />
                                                                        <span>WE REVIEWED YOUR PROJECT DETAILS AND ASSIGNED A PRICE ACCORDING TO YOUR CURRENT REQUIREMENTS.<br /><br />
                                                                                PAY ADVANCE (20% Of Total Price) TO CONFIRM YOUR ORDER</span><br /><br />
                                                                        <strong style={{ color: 'blue', fontSize: '18px' }}>PAY USING QR CODE</strong><br /><br />
                                                                        <img src={Qrcode} alt="QR" className="qrcode" /><br />
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> : null}

                                                        {/* for status > 59  */}
                                                        {order.status > 59 ?
                                                            <Card>
                                                                <Card.Header>
                                                                    <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="3">
                                                                        Order Confirmed
                                                                        <Image src={CheckImg} fluid />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="3">
                                                                    <Card.Body>
                                                                        <p><strong style={{ color: 'green' }}>ADVANCE PAID</strong></p>
                                                                        <span>YOUR ORDER WAS CONFIRMED, OUR DEVELOPMET WILL START VERY SOON</span>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> : null}

                                                        {/* for status > 79 */}
                                                        {order.status > 79 ?
                                                            <Card>
                                                                <Card.Header>
                                                                    <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="4">
                                                                       Development
                                                                        <Image src={CheckImg} fluid />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="4">
                                                                    <Card.Body>
                                                                        <span style={{ fontSize: '16px' }}>ESTIMATED DELIVERY : {order.deliveryDate}</span><br /><br />
                                                                        <p><a href={order.devUrl} target="_blank" rel="noreferrer">TRACK DEVELOPMENT</a></p>
                                                                        <span>You can send us additional REQUIREMENTS from here.</span><br /><br />
                                                                        <Form.File disabled={order.status > 89 ? true : false} id="dev_files" multiple /><br />
                                                                        {progress === 0 || progress === 100 ? <Button className="send" onClick={() => uploadHandler(order.project)} disabled={order.status > 89 ? true : false}>UPLOAD FILES</Button> : null}
                                                                        <br />{error !== '' ? <span style={{ color: 'red' }}>{error}</span> : null}
                                                                        {progress > 0 && progress < 100 ? <ProgressBar now={progress} /> : null}
                                                                        <br />{progress === 100 ? <span style={{ color: 'green' }}>UPLOAD COMPLETE!</span> : null}
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> : null}

                                                        {/* for status == 90     */}
                                                        {order.status === 90 ?
                                                            <Card>
                                                                <Card.Header>
                                                                    <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="5">
                                                                        Out for delivery
                                                                        <Image src={CheckImg} fluid />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="5">
                                                                    <Card.Body>
                                                                        <p>TOTAL PRICE: &nbsp;₹{order.price}/-</p><br />
                                                                        <span>DEVELOPMENT COMPLETED, YOUR PROJECT IS OUT FOR DELIVERY</span><br />
                                                                        <span>PAY TOTAL PRICE TO DELIVER YOUR PROJECT.</span>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> : null}

                                                        {/* for status == 100    */}
                                                        {order.status === 100 ?
                                                            <Card>
                                                                <Card.Header>
                                                                    <Accordion.Toggle className="ToogleBtn" variant="link" eventKey="6">
                                                                        Delivered 🙂
                                                                        <Image src={CheckImg} fluid />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="6">
                                                                    <Card.Body>
                                                                        <span>Thanks For Choosing Us!</span><br />
                                                                        <span>It Feels Great To Complete Your Project, We Think You are Satisfied With Our Efforts.</span><br /><br />
                                                                        {order.rating === '' && order.review === '' ? <div><p><strong>PLEASE RATE YOUR EXPERIENCE!</strong></p>
                                                                            <div class="rate">
                                                                                <input type="radio" id="star5" name="rate" value="5" onChange={(e) => setrating(e.target.value)} />
                                                                                <label for="star5" title="text">5 stars</label>
                                                                                <input type="radio" id="star4" name="rate" value="4" onChange={(e) => setrating(e.target.value)} />
                                                                                <label for="star4" title="text">4 stars</label>
                                                                                <input type="radio" id="star3" name="rate" value="3" onChange={(e) => setrating(e.target.value)} />
                                                                                <label for="star3" title="text">3 stars</label>
                                                                                <input type="radio" id="star2" name="rate" value="2" onChange={(e) => setrating(e.target.value)} />
                                                                                <label for="star2" title="text">2 stars</label>
                                                                                <input type="radio" id="star1" name="rate" value="1" onChange={(e) => setrating(e.target.value)} />
                                                                                <label for="star1" title="text">1 star</label>
                                                                            </div>
                                                                            <Form.Group>
                                                                                <Form.Control value={review} onChange={(e) => setreview(e.target.value)} as="textarea" rows={3} placeholder="Share your experience with us.. " />
                                                                            </Form.Group>
                                                                            <Button onClick={() => reviewHandler(order.id)} className="send">SEND</Button></div> : null}
                                                                        {order.rating !== '' && order.review !== '' ? <div><strong>Thanks for Rating!</strong><br /><br />{order.review}</div> : null}
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> : null}
                                                    </Accordion>
                                                </div>
                                            </div> : null}
                                    </Card.Body>
                                </Card>
                            </Col>
                        )
                    })}
                </Container>
            </header >
            <div style={{ margin: '20px 0' }}>
                <center>
                    <p style={{ fontWeight: '600' }}>Copyright © 2021 Designed and Developed by TeamTechSeminal</p>
                </center>
            </div>
        </div >
    );
}

export default withRouter(MyOrders);